













import { Component, Vue } from "vue-property-decorator"

@Component({
  name: "Ygabn"
})
export default class Ygabn extends Vue {
  get recordCode() {
    if (typeof window === "undefined") return "44010602014468" // SSR fallback

    const hostname = window.location.hostname
    switch (hostname) {
      case "ghzs666.com":
        return "44010602014465"
      case "ghzs66.com":
        return "44010602014467"
      case "ghzs6.com":
        return "44010602014466"
      case "ghzs.com":
      default:
        return "44010602014468"
    }
  }

  get recordLink() {
    return `https://beian.mps.gov.cn/#/query/webSearch?code=${this.recordCode}`
  }

  get recordText() {
    return `粤公网安备${this.recordCode}号`
  }
}
